import React from 'react';

import cx from 'classnames';
import { useIsSidebarOpen } from '@shared/hooks';

import s from './LoaderDots.module.css';

export const LoaderDots = ({ variant = 'dark', disableBackdrop = false }) => {
    const { isSidebarOpen, sidebarWidth } = useIsSidebarOpen();

    return (
        <div className={cx(s.loaderWrapper, s[variant], disableBackdrop && s.light)}>
            <div
                className={s.spinner}
                style={isSidebarOpen ? { left: `calc(50% + ${sidebarWidth / 2}px)` } : undefined}
            >
                <div className={cx(s.bounce1, disableBackdrop && s.bounceDark)} />
                <div className={cx(s.bounce2, disableBackdrop && s.bounceDark)} />
                <div className={cx(s.bounce3, disableBackdrop && s.bounceDark)} />
            </div>
        </div>
    );
};
